const API_URL = process.env.REACT_APP_LOCATION_API_URL;
const getTenant = () => localStorage.getItem("tenant");

// Fetch all locations
export const fetchLocations = async () => {
  const res = await fetch(`${API_URL}/locations`, {
    credentials: "include",
    headers: { "X-Tenant": getTenant() }
  });
  return res.json();
};

// Add new location
export const addLocation = async (payload) => {
  const res = await fetch(`${API_URL}/add`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "X-Tenant": getTenant()
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });
  return res.json();
};

// Update location
export const updateLocation = async (id, payload) => {
  const res = await fetch(`${API_URL}/location/${id}`, {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json",
      "X-Tenant": getTenant()
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });
  return res.json();
};

// Delete
export const deleteLocation = async (id) => {
  const res = await fetch(`${API_URL}/${id}`, {
    method: "DELETE",
    headers: { "X-Tenant": getTenant() },
    credentials: "include"
  });
  return res.json();
};